import { Drawer } from "antd";
import React from "react";
import { useStyles } from "./style";
import classnames from "classnames";

const DrawerComponent = ({
    size,
    title,
    isClosable,
    children,
    onOpen,
    onClose,
    footer,
    extraClass
}: any) => {
    const classes = useStyles();
    return (
        <Drawer className={classnames(classes.drawerWrapper, extraClass)}
            width={size}
            title={title}
            closable={isClosable}
            open={onOpen}
            onClose={onClose}
            footer={footer}
        >
            {children && children}
        </Drawer>
    );
};

export default DrawerComponent;
